import type { LiveSheet, LiveSheetAbility, LiveSheetItem, LiveSheetSpell } from "../../types/generated/live";

// What the live state holds: its collections keyed by id, without the version.
type Stored = Partial<Omit<LiveSheet, "version" | "inventory" | "abilities" | "spells">> & {
	inventory?: Record<string, LiveSheetItem>;
	abilities?: Record<string, LiveSheetAbility>;
	spells?: Record<string, LiveSheetSpell>;
};

export type SheetView = Omit<LiveSheet, "version" | "inventory" | "abilities" | "spells"> & {
	inventory: LiveSheetItem[];
	abilities: LiveSheetAbility[];
	spells: LiveSheetSpell[];
};

export function toSheetView(stored: Stored): SheetView | null {
	if (!stored.sheet || !stored.derived || !stored.meta) return null;
	const inventory = Object.values(stored.inventory ?? {}).sort((a, b) => a.position - b.position);
	const { sheet, derived, meta, id, record_type } = stored;
	return { id, record_type, sheet, derived, meta, inventory, abilities: Object.values(stored.abilities ?? {}), spells: Object.values(stored.spells ?? {}) };
}

// What the inventory components read of their owner: a sheet, or the campaign, which keeps no load and equips nothing, so
// `derived` is there only on a sheet.
export type InventoryView = {
	id: string;
	record_type: string;
	sheet: Pick<SheetView["sheet"], "money_gp" | "money_sp" | "money_cp">;
	inventory: LiveSheetItem[];
	derived?: SheetView["derived"];
};
